import Api from "api/menu.api";
import {API} from "utils/api";

export const serviceMenuUpdateAction = async (id) => {
    const res = await API.post(Api.postAction.replace(':id', id), {action: 'is_active'});
    return !!res;
}

export const serviceMenuDestroy = async (id) => {
    const res = await API.delete(Api.deleteDestroy.replace(':id', id));
    return !!res;
}

export const serviceMenuWidgetDestroy = async (id) => {
    const res = await API.delete(Api.deleteWidgetDestroy.replace(':widgetId', id));
    return !!res;
}

export const serviceMenuSave = async (data) => {
    try {
        let res = '';
        if (data?.id) res = await API.put(Api.putUpdate.replace(':id', data.id), data)
        else res = await API.post(Api.postCreate, data)

        return !!res;
    } catch (e) {
        return false
    }
}

export const serviceMenuItem = async (id) => {
    const res = await API.get(Api.getId.replace(':id', id))
    if (res) return res;
    return false;
}

export const serviceMenuOrder = async (id, data) => {
    const res = await API.post(Api.postOrder.replace(':id', id), data)
    if (res) return res;
    return false;
}

export const serviceMenuWidgetOrder = async (id, data) => {
    const res = await API.post(Api.postWidgetOrder.replace(':widgetId', id), data)
    if (res) return res;
    return false;
}
